export default __webpack_public_path__ + "static/media/biometricsolutions.f5d95433.jpg";